module.exports = __webpack_public_path__ + "img/icon_k_line.4305b1c2.gif";